import { NivelAlgoritmoEnum, TextoNivelAlgoritmoEnum } from "../enums";

export function checarTitulo(nivel: number): string {
  if (nivel === NivelAlgoritmoEnum.FACIL) {
    return TextoNivelAlgoritmoEnum.FACIL;
  } else if (nivel === NivelAlgoritmoEnum.MEDIO) {
    return TextoNivelAlgoritmoEnum.MEDIO;
  } else {
    return TextoNivelAlgoritmoEnum.DIFICIL;
  }
}
